import type { Entity } from '@models/Entity'

export const ENTITIES: Record<string, Entity['type']> = {
  PROJECT: 'project',
  PROJECTDOSSIER: 'projectdossier',
  OPDRACHT: 'opdracht',
  DEELNEMER_OPDRACHT: 'opdracht/deelnemer',
  HOOFDNET_OPDRACHT: 'opdracht-hoofdnet',
}
